/**
 * app优惠券列表
 */
export enum HB_BUSINESS_TYPE {
  // 0.单车  1.助力车 2.礼品券 3.电动车券 4.打车券 5.顺风车券
  /**
   * 单车
   */
  BIKE = 0,
  /**
   * 电单车
   */
  EBIKE = 1,
  /**
   * 礼品券
   */
  GIFT = 2,
  /**
   * 电动车
   */
  EVEHICLE = 3,
  /**
   * 打车
   */
  TAXI = 4,
  /**
   * 顺风车
   */
  HITCH = 5,
}

/**
 * 业务线类目
 */
export enum CategoryId {
  // ALL = 0, // 所有
  BIKE = '101', // 单车
  TAXI = '102', // 打车
  EBIKE = '103', // 助力车（电单车）
  HITCH = '104', // 顺风车
  EVEHICLE = '105', // 电动车
}

/** 两轮类目 */
export type TWO_WHEELS_CATEGORY = CategoryId.BIKE | CategoryId.EBIKE;

export const BusinessMap = {
  [CategoryId.BIKE]: HB_BUSINESS_TYPE.BIKE,
  [CategoryId.TAXI]: HB_BUSINESS_TYPE.TAXI,
  [CategoryId.EBIKE]: HB_BUSINESS_TYPE.EBIKE,
  [CategoryId.HITCH]: HB_BUSINESS_TYPE.HITCH,
  [CategoryId.EVEHICLE]: HB_BUSINESS_TYPE.EVEHICLE,
};

export function transformBusinessEum(categoryType: CategoryId): HB_BUSINESS_TYPE {
  return BusinessMap[categoryType] || BusinessMap[CategoryId.BIKE];
}

export function transformToCategoryId(bizType?: HB_BUSINESS_TYPE | string | null): string {
  if (!bizType) {
    return '0';
  }

  const resolvedBizType = +bizType;
  return (
    Object.keys(BusinessMap).find((key) => BusinessMap[key as CategoryId] === resolvedBizType)
    || bizType
  ).toString();
}

/** 充值类型常量 */
export const CHARGE_TYPE = {
  PAY_AND_SIGN: 1307 /** 抖音签约并支付 */,
  PAY_AND_SIGN_MONTHLY: 1308 /** 抖音连续包月骑行卡免密代扣 */,
  ALIPAY_CONTINUOUS_MONTHLY: 1309 /** 支付宝连续包月 */,
};

/** 订单类型常量 */
export const ORDER_TYPE = {
  NORMAL: 0 /** 普通订单 */,
};

/** 签约场景常量 */
export const SIGN_SCENE = {
  HELLO_COUPON_MONTHLY: 'HELLO_COUPON_MONTHLY' /** 抖音骑行卡连续包月 */,
  COUPON_CARD_MONTHLY: 'COUPON_CARD_MONTHLY' /** 支付宝连续包月 */,
};

/** 包月场景常量 */
export const COUPON_MONTHLY_SCENE = {
  ALIPAY_MONTHLY_PROPERTY: 'ALIPAY_MONTHLY_PROPERTY' /** 支付宝包月 */,
  DOUYIN_MONTHLY_PROPERTY: 'DOUYIN_MONTHLY_PROPERTY' /** 抖音包月 */,
};

/** 免密场景常量 */
export const PASSWORD_SCENE = {
  ALIPAY_PASSWORD_PROPERTY: 'ALIPAY_PASSWORD_PROPERTY' /** 支付宝免密 */,
  DOUYIN_PASSWORD_PROPERTY: 'DOUYIN_PASSWORD_PROPERTY' /** 抖音免密 */,
};
